var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyTableItem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 1740,
    height: 62,
    "aria-labelledby": titleId,
    viewBox: "0 0 2500 62",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, "Loading...") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "loading-aria"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    clipPath: "url(#clip-path)",
    style: {
      fill: "url(\"#fill\")"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 30,
    r: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    rx: 0,
    ry: 0,
    width: 32,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 11,
    rx: 0,
    ry: 0,
    width: 245,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 40,
    rx: 0,
    ry: 0,
    width: 225,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 18,
    rx: 0,
    ry: 0,
    width: 200,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662,
    y: 18,
    rx: 0,
    ry: 0,
    width: 95,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 762,
    y: 18,
    rx: 0,
    ry: 0,
    width: 115,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 33,
    rx: 0,
    ry: 0,
    width: 85,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 547,
    y: 33,
    rx: 0,
    ry: 0,
    width: 80,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 33,
    rx: 0,
    ry: 0,
    width: 110,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 747,
    y: 33,
    rx: 0,
    ry: 0,
    width: 130,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 914,
    y: 19,
    rx: 0,
    ry: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948,
    y: 20,
    rx: 0,
    ry: 0,
    width: 260,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948,
    y: 33,
    rx: 0,
    ry: 0,
    width: 260,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248,
    y: 19,
    rx: 0,
    ry: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1282,
    y: 25,
    rx: 0,
    ry: 0,
    width: 150,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1497,
    y: 18,
    rx: 0,
    ry: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1531,
    y: 24,
    rx: 0,
    ry: 0,
    width: 170,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1796,
    y: 18,
    rx: 0,
    ry: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1830,
    y: 24,
    rx: 0,
    ry: 0,
    width: 180,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2075,
    y: 18,
    rx: 0,
    ry: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2109,
    y: 24,
    rx: 0,
    ry: 0,
    width: 120,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2274,
    y: 18,
    rx: 0,
    ry: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2308,
    y: 24,
    rx: 0,
    ry: 0,
    width: 70,
    height: 10
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.599964,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "1.25s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1.59996,
    stopColor: "#cbcbcb",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "1.25s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 2.59996,
    stopColor: "#f3f3f3",
    stopOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "1.25s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyTableItem);
export default __webpack_public_path__ + "static/media/company_table_item.0b7e8173a5225f4aad53ee79626b4b43.svg";
export { ForwardRef as ReactComponent };